import { useCreditGateStore } from "@/hooks/useCreditGateModal";
import { useAuthStore } from "@/store/authStore";

import { InsufficientCreditsMemberNotice } from "./InsufficientCreditsMemberNotice";
import { InsufficientCreditsUpgradeDialog } from "./InsufficientCreditsUpgradeDialog";

/** Mounted once in `Layout`; owns admin/member branching so surfaces only report a code. */
export const CreditGateModalHost = () => {
  const request = useCreditGateStore((state) => state.request);
  const close = useCreditGateStore((state) => state.closeCreditGateModal);
  const user = useAuthStore((state) => state.user);

  const isAdmin = Boolean(user?.is_admin || user?.is_company_admin);
  const onOpenChange = (open: boolean) => {
    if (!open) close();
  };

  if (!request) return null;

  return isAdmin ? (
    <InsufficientCreditsUpgradeDialog
      open
      onOpenChange={onOpenChange}
      balance={request.balance}
      userEffectiveAvailable={request.user_effective_available}
      requiredAction={request.required_action}
      context={request.context}
    />
  ) : (
    <InsufficientCreditsMemberNotice
      open
      onOpenChange={onOpenChange}
      requiredAction={request.required_action}
      userEffectiveAvailable={request.user_effective_available}
    />
  );
};

export default CreditGateModalHost;
